import React from 'react'

import T from 'components/FormattedMessage'
import MainLayout from 'components/MainLayout'

import { FriendsResponse, UserListResponse, ReferralsResponse } from 'protos'

import MyFriendsTab from './tabs/MyFriendsTab'
import InviteFriendsTab from './tabs/InviteFriendsTab'

interface Props {
  friendRequests?: number | null
  getUserFriends: () => Promise<FriendsResponse>
  getUserReferrals: () => Promise<ReferralsResponse>
  searchUsers: (text: string) => Promise<UserListResponse>
  loginToFacebook: () => Promise<any> // tslint:disable-line:no-any
  onChallenge: (userId: string) => any // tslint:disable-line:no-any
}

interface State {

}

class FriendsScreen extends React.Component<Props, State> {
  private renderMyFriends = () => (
    <MyFriendsTab
      getUserFriends={this.props.getUserFriends}
      searchUsers={this.props.searchUsers}
      loginToFacebook={this.props.loginToFacebook}
      onChallenge={this.props.onChallenge}
    />
  )

  private renderInviteFriends = () => (
    <InviteFriendsTab getUserReferrals={this.props.getUserReferrals} />
  )

  render() {
    return (
      <MainLayout
        tabs={[
          {
            title: <T id="root_tab_friends" />,
            url: '/friends',
            component: this.renderMyFriends,
            badgeContent: this.props.friendRequests,
          },
          {
            title: <T id="referrals_title" />,
            url: '/friends/invite',
            component: this.renderInviteFriends,
          },
        ]}
      />
    )
  }
}

export default FriendsScreen
